import { Controller } from "@hotwired/stimulus"

// A UI "back" button. When the user reached this page from within the app
// (same-origin referrer + real session history) it goes back like the browser
// button, restoring the previous page — e.g. the filtered task listing — exactly.
// Otherwise (deep link, shared URL, external referrer) it follows the element's
// href, which should point at a sensible fallback landing page.
export default class extends Controller {
  back(event) {
    let sameOrigin = false
    try {
      const ref = document.referrer
      sameOrigin = ref !== "" && new URL(ref).origin === window.location.origin
    } catch (_e) {
      sameOrigin = false
    }

    if (sameOrigin && window.history.length > 1) {
      event.preventDefault()
      window.history.back()
    }
    // else: let the link's href (fallback landing page) handle navigation
  }
}
